Namespace 'Common.Sessions'

class Common.Sessions.NewSessionModalView extends Backbone.View
  template: JST['backbone/templates/common/sessions/new_session_modal']

  events:
    'click .start-button': '_createNewSession'

  initialize: ({description} = {}) ->
    @description = description || ''

  render: ->
    @$el.html @template
      description: @description
    @

  _createNewSession: ->
    @trigger('session:create')
